// Silnik formularza zgłoszeniowego (brief) — bootstrap.
// Tryby: full (brief-form.php), materials / reply (brief-materials.php).
// Markup jest server-rendered; bez JS wszystkie kroki są widoczne, a wysyłkę
// zastępuje komunikat noscript.

import { initSteps } from "./steps.js";
import { initValidate, validateField, setFieldError, clearFieldError } from "./validate.js";
import { initConditionals } from "./conditional.js";
import { initDraft } from "./draft.js";
import { initUploads } from "./upload.js";
import { initColors } from "./colors.js";
import { initSubmit } from "./submit.js";
import { initReview } from "./review.js";
import { initAssists } from "./assists.js";
import { initExamples } from "./examples.js";
import { initTheme } from "./theme.js";
import { announce, focusHeading } from "./a11y.js";

document.addEventListener("DOMContentLoaded", () => {
    initTheme();

    const form = document.querySelector("form[data-brief-mode]");
    if (!form) return;

    document.body.classList.add("brief--js");

    // ukryte pole source z parametru ?src= (skąd przyszedł klient)
    const src = new URLSearchParams(window.location.search).get("src");
    const sourceInput = form.querySelector('input[name="source"]');
    if (src && sourceInput) sourceInput.value = src.slice(0, 100);

    const mode = form.dataset.briefMode;
    const api = {};

    initValidate(form);
    initAssists(form);
    api.uploads = initUploads(form);

    if (mode === "full") {
        api.conditionals = initConditionals(form);
        api.steps = initSteps(form, {
            onStepChange(step) {
                // podsumowanie budujemy dopiero przy wejściu — musi pokazywać
                // stan z tej chwili, nie z momentu załadowania strony
                if (api.review && step === api.steps.getReviewNr()) api.review.build();
                if (api.steps) api.steps.paintTaskList();
            },
            onRequestRozsz() {
                if (api.conditionals) api.conditionals.setRozsz(true, false);
            },
        });
        api.review = initReview(form, api);
        api.draft = initDraft(form, api);
        initColors(form); // po restore szkicu — odtwarza wiersze pickerów
        api.examples = initExamples(form); // po restore: przykłady wg zapisanej branży
        initSubmit(form, api);
        return;
    }

    // ---- tryby magic-link: pojedynczy widok, prosty POST ----
    api.conditionals = initConditionals(form);
    initLinkSubmit(form, api);
});

function initLinkSubmit(form, api) {
    const submitBtn = form.querySelector("[data-submit]");
    const formError = form.querySelector("[data-form-error]");
    let busy = false;

    function fail(message) {
        if (formError) {
            formError.textContent = message;
            formError.hidden = false;
            focusHeading(formError);
        }
    }

    form.addEventListener("submit", (event) => {
        event.preventDefault();
        if (busy) return;
        if (formError) formError.hidden = true;

        // walidacja widocznych pól (np. wymagana treść odpowiedzi)
        let firstBad = null;
        form.querySelectorAll("input:not([type=file]), textarea").forEach((input) => {
            if (input.disabled) return;
            const message = validateField(input, form);
            if (message) {
                setFieldError(input, message);
                if (!firstBad) firstBad = input;
            } else {
                clearFieldError(input);
            }
        });
        if (firstBad) {
            firstBad.focus();
            return;
        }

        const data = new FormData(form);
        const files = api.uploads ? api.uploads.collect() : {};
        Object.entries(files).forEach(([name, list]) => {
            list.forEach((file) => data.append(name, file, file.name));
        });

        const hasContent =
            Object.keys(files).length > 0 ||
            Array.from(data.entries()).some(
                ([key, value]) =>
                    !["token", "widok"].includes(key) && typeof value === "string" && value.trim() !== ""
            );
        if (!hasContent) {
            fail("Dodaj pliki albo wpisz wiadomość — formularz jest pusty.");
            return;
        }

        busy = true;
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = "Wysyłanie…";
        }

        fetch(form.dataset.endpoint, { method: "POST", body: data })
            .then((res) => res.json().then((body) => ({ status: res.status, body })))
            .then(({ status, body }) => {
                busy = false;
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = submitBtn.dataset.label || "Wyślij";
                }
                if (status === 200 && body && body.ok) {
                    form.hidden = true;
                    const success = document.querySelector("[data-success]");
                    if (success) {
                        success.hidden = false;
                        focusHeading(success.querySelector("h2"));
                    }
                    announce("Wysłane. Dziękujemy!");
                    return;
                }
                if (body && body.fields) {
                    Object.entries(body.fields).forEach(([name, message]) => {
                        const input = form.querySelector('[name="' + CSS.escape(name) + '"]');
                        if (input) setFieldError(input, message);
                    });
                    return;
                }
                fail(body && body.message ? body.message : "Nie udało się wysłać. Spróbuj ponownie.");
            })
            .catch(() => {
                busy = false;
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = submitBtn.dataset.label || "Wyślij";
                }
                fail("Nie udało się wysłać. Sprawdź połączenie z internetem i spróbuj ponownie.");
            });
    });
}
